import { IGetInState } from './IGetInState';

export const initialState: IGetInState = {
  avatars: {},
  currentScreen: 'LOGIN_EMAIL',
  routeAccessedBeforeLogin: undefined,
};
